export const stageConfig = [
  {
    stageId: 1,
    steps: [
      {
        stepId: 1,
        stepIdCompletedToBeEnabled: 1,
        stageId: 1,
        title: 'main',
        path: '/publicador-profesionales/main'
      },
      {
        stepId: 2,
        stepIdCompletedToBeEnabled: 1,
        stageId: 1,
        title: 'location',
        path: '/publicador-profesionales/location'
      }
    ]
  },
  {
    stageId: 2,
    steps: [
      {
        stepId: 3,
        stepIdCompletedToBeEnabled: 2,
        stageId: 2,
        title: 'multimedia',
        path: '/publicador-profesionales/multimedia'
      },
      {
        stepId: 4,
        stepIdCompletedToBeEnabled: 3,
        stageId: 2,
        title: 'features',
        path: '/publicador-profesionales/features'
      },
      {
        stepId: 5,
        stepIdCompletedToBeEnabled: 4,
        stageId: 2,
        title: 'extras',
        path: '/publicador-profesionales/extras'
      },
      {
        stepId: 6,
        stepIdCompletedToBeEnabled: 5,
        stageId: 2,
        title: 'description',
        path: '/publicador-profesionales/description'
      }
    ]
  },
  {
    stageId: 3,
    steps: [
      {
        stepId: 7,
        stepIdCompletedToBeEnabled: 6,
        stageId: 3,
        title: 'price',
        path: '/publicador-profesionales/price'
      },
      {
        stepId: 8,
        stepIdCompletedToBeEnabled: 7,
        stageId: 3,
        title: 'publish',
        path: '/publicador-profesionales/publish'
      }
    ]
  }
];

export const stepsConfigFlat = stageConfig.flatMap(stage => stage.steps);
